import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "./footer.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [RouterModule, CommonModule, TranslateModule.forChild()],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
